import { render } from "./default.vue?vue&type=template&id=616ea252"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/form-sections/default.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "616ea252"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('616ea252', __exports__)) {
    console.log('reload')
    api.reload('616ea252', __exports__)
  }
  
  module.hot.accept("./default.vue?vue&type=template&id=616ea252", () => {
    console.log('re-render')
    api.rerender('616ea252', render)
  })

}


export default __exports__